import React from 'react'
import { LOGO_ACCESSIMG_IMG } from '../../../utills/image-constant'

const AccessPermissionpage = () => {
    return (
        <>
            <div className="caspera_dashboard_content">
                <div className="container-fluid px-3">
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <img className='access_logo' src={LOGO_ACCESSIMG_IMG} alt='...' />
                        <h4 className='fw-5 mt-3'>You Don't Have Permission To Access This Page !</h4>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AccessPermissionpage;
